import URLConfig from './URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();

// Admin Coupons page. Admins only: a manager would get 403, and a 403 signs the user out, so pages must check
// AuthenticationService.canManageSettings() before calling.
class CouponService {

    list({ status, q } = {}) {
        const query = new URLSearchParams()
        if (status && status !== 'all') query.set('status', status)
        if (q) query.set('q', q)
        const qs = query.toString()
        return axiosInstance().get(path + "/admin/coupons" + (qs ? "?" + qs : ""));
    }

    save(id, form) {
        return id ? axiosInstance().put(path + "/admin/coupons/" + id, form) : axiosInstance().post(path + "/admin/coupons", form);
    }

    setActive(id, active) {
        return axiosInstance().patch(path + "/admin/coupons/" + id + "/active", { active });
    }

    remove(id) {
        return axiosInstance().delete(path + "/admin/coupons/" + id);
    }

    redemptions(id) {
        return axiosInstance().get(path + "/admin/coupons/" + id + "/redemptions");
    }
}

export default new CouponService()
